export enum FeatureFlag {
    DYNAMIC_SUBTYPE_MANAGEMENT_ENABLED = 'DYNAMIC_SUBTYPE_MANAGEMENT_ENABLED',
    TOS_TOGGLE_DOCUSIGN_ENVELOPE = 'TOS_TOGGLE_DOCUSIGN_ENVELOPE',
    RETROFIT_CONTRACTS_ENABLED = 'RETROFIT_CONTRACTS_ENABLED',
    SALESOS_FLOW_ENABLED = 'SALESOS_FLOW_ENABLED',
}
